export default "__VITE_ASSET__DdJgEUFP__"